const defaultCurrencyValues: { location: string; options: Intl.NumberFormatOptions } = {
    location: "cs-CZ",
    options: {
        style: "currency",
        currency: "CZK",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    },
};

const defaultFloatValues: { location: string; options: Intl.NumberFormatOptions } = {
    location: "cs-CZ",
    options: {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    },
};

const currencyFormatter = (options?: Intl.NumberFormatOptions) => {
    return new Intl.NumberFormat(defaultCurrencyValues.location, { ...defaultCurrencyValues.options, ...options });
};

const floatFormatter = (options?: Intl.NumberFormatOptions) => {
    return new Intl.NumberFormat(defaultFloatValues.location, { ...defaultFloatValues.options, ...options });
};

export function NumberToCZK(number: number, options?: Intl.NumberFormatOptions): string {
    return currencyFormatter(options).format(number);
}

export function NumberToFloat(number: number, options?: Intl.NumberFormatOptions): string {
    return floatFormatter(options).format(number);
}

export function NumberToCZKExtraDigits(number: number, digits?: number, options?: Intl.NumberFormatOptions): string {
    return currencyFormatter({
        minimumFractionDigits: digits ?? 4,
        maximumFractionDigits: digits ?? 4,
        ...options,
    }).format(number);
}

export function NumberExtraDigits(number: number, digits?: number, options?: Intl.NumberFormatOptions): string {
    return floatFormatter({
        minimumFractionDigits: digits ?? 4,
        maximumFractionDigits: digits ?? 4,
        ...options,
    }).format(number);
}

export function NumberToCZKWhole(number: number, options?: Intl.NumberFormatOptions): string {
    const roundedNumber = Math.round(number);
    return currencyFormatter({
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        ...options,
    }).format(roundedNumber);
}
